import i18n from '@/i18n/i18n'
import { PostService } from '@/services/admin/PostService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['title']

export const state = {
  posts: [],
  post: {},
  meta: null
}

export const mutations = {
  SET_POSTS(state, posts) {
    state.posts = posts.data
    state.meta = posts.meta
  },
  SET_POST(state, post) {
    state.post = post
  },
  ADD_POST(state, post) {
    state.posts.unshift(post)
  },
  DELETE_POST(state, postToRemove) {
    state.posts = state.posts.filter(post => {
      return post.id !== postToRemove.id
    })
  }
}

export const actions = {
  getPosts({ commit }, query) {
    return new Promise(resolve => {
      let postService = new PostService()
      let newQuery = build_query(query, allowedFilters, [], null)

      postService.getPosts(newQuery).then(response => {
        commit('SET_POSTS', response)
        resolve(response.data)
      })
    })
  },
  getPost({ commit }, post) {
    return new Promise(resolve => {
      let postService = new PostService()

      postService.getPost(post).then(response => {
        commit('SET_POST', response.data)
        resolve(response.data)
      })
    })
  },
  createPost({ commit, dispatch }, post) {
    return new Promise((resolve, reject) => {
      let postService = new PostService()
      postService
        .createPost(post)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.post.create_post_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          commit('ADD_POST', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.post.create_post_error') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updatePost({ dispatch }, data) {
    return new Promise(resolve => {
      let postService = new PostService()
      postService.updatePost(data.id, data.form).then(response => {
        const notification = {
          type: 'success',
          message: t('store.admin.post.update_post_success')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  },
  deletePost({ commit, dispatch }, post) {
    return new Promise(resolve => {
      let postService = new PostService()
      postService.deletePost(post.id).then(response => {
        commit('DELETE_POST', post)
        const notification = {
          type: 'warning',
          message: t('store.admin.post.delete_post_success')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response.data)
      })
    })
  }
}
